import { render } from "./CustomerBpmEmptyCard.vue?vue&type=template&id=4edbfdec&scoped=true"
import script from "./CustomerBpmEmptyCard.vue?vue&type=script&lang=js"
export * from "./CustomerBpmEmptyCard.vue?vue&type=script&lang=js"

import "./CustomerBpmEmptyCard.vue?vue&type=style&index=0&id=4edbfdec&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edbfdec"]])

export default __exports__